import { ComponentType, memo, PropsWithChildren } from 'react';

import {
  PrimaryButtonProps,
  useOverflowStatus,
  PrimaryButton,
} from '@atlaskit/atlassian-navigation';
import { ButtonItem } from '@atlaskit/menu';

import { AnalyticsEvent } from 'src/components/navigation/src/types';

type Props = Omit<PrimaryButtonProps, 'onClick'> & {
  isClientLink?: boolean;
  linkComponent?: ComponentType<PropsWithChildren<any>>;
  onClick?: () => void;
  publishUiEvent: (event: AnalyticsEvent) => void;
  analyticsLabel: string;
};

export const HorizontalNavPrimaryItem = memo((props: Props) => {
  const {
    linkComponent,
    isClientLink,
    onClick,
    analyticsLabel,
    publishUiEvent,
    ...linkProps
  } = props;
  const overflowStatus = useOverflowStatus();
  const analyticsEvent = {
    action: 'clicked',
    actionSubject: 'navigationItem',
    actionSubjectId: analyticsLabel,
    source: 'navigation',
    attributes: {
      itemIsGlobalHorizontalNav: true,
    },
  };

  return overflowStatus.isVisible ? (
    <PrimaryButton
      {...linkProps}
      onClick={() => {
        if (onClick) onClick();
        publishUiEvent(analyticsEvent);
      }}
      component={isClientLink ? linkComponent : undefined}
    />
  ) : (
    <ButtonItem
      onClick={e => {
        e.preventDefault();
        if (onClick) onClick();
        publishUiEvent(analyticsEvent);
        if (linkProps.href) {
          window.location.href = linkProps.href;
        }
      }}
      {...linkProps}
    />
  );
});
